import React from "react";
import "../styles/sustainability.css";

const sustainability = () => {
  return (
    <>
      <div className="sustainability-landing">
        <h1>
          A word from our CEO on <strong>sustainability</strong>
        </h1>
        <h3>Gary Colleran</h3>
        <h1 id="quote-start-landing">‘‘</h1>
        <p>
          I’m proud to say that at Healthcare interAction we drive positive
          change by adopting best practice and leading by example. ESG is no
          exception. For us, it’s more than a compliance requirement, it’s a
          fundamental way of challenging how we operate to ensure we are greener
          and more equitable in all we do, embracing sustainable business
          practices and adding long-term value to both our stakeholders and the
          planet.
        </p>
        <h1 id="quote-end-landing">’’</h1>
      </div>

      <section className="sustainability-wrap">
        <div className="sustainability-community">
          <h2>Community</h2>
          <p>
            We believe in fostering a strong sense of community. Internally, we
            prioritise the well-being and growth of our employees, fostering a
            workplace that encourages diversity, inclusivity, and personal
            development. Externally, we actively engage with the communities we
            serve, supporting sustainability initiatives, and giving back
            through various charitable efforts. We understand that a thriving
            internal and external community is not only integral to our success
            but to the collective well-being of our society.
          </p>
        </div>

        <div className="sustainability-fairness">
          <h2>Fairness</h2>
          <p>
            We are dedicated to treating our staff, customers, and the
            individuals we train with the utmost equity and respect. This means
            fostering an inclusive and diverse workplace where every team
            member's voice is heard and valued, offering products and services
            that prioritise ethical and socially responsible practices, and
            ensuring that our training and coaching services empower and support
            individuals from all walks of life.
          </p>
        </div>

        <div className="sustainability-netZero">
          <h2>Net Zero</h2>
          <p>
            Our commitment to a sustainable future is exemplified by our
            unwavering dedication to achieving net-zero emissions. We recognise
            that climate change is one of the most pressing global challenges,
            and we are determined to do our part in combatting it. We have
            integrated sustainability practices into every facet of our
            operations, from reducing our carbon footprint through responsible
            energy use to promoting eco-friendly alternatives in our services.
            We actively support and empower our clients to make informed choices
            that contribute to a greener and more socially responsible world.
          </p>
        </div>
      </section>

      <section className="quote">
        <h1 className="quoteStart" id="quote-start-sustainability">
          ‘‘
        </h1>
        <p>
          Thank you so much for the fantastic training! One of the best I have
          been to in 18 years. I got so many great insights to bring more value
          to customer meetings!
        </p>
        <h1 className="quoteEnd" id="quote-end-sustainability">
          ’’
        </h1>
      </section>
    </>
  );
};

export default sustainability;
